import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { GiCrossedBones } from "react-icons/gi";
import { LuSave } from "react-icons/lu";
import * as Yup from "yup";

const AddNewProfile = () => {
    const [profilePreview, setProfilePreview] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const initialValues = {
        initial: "",
        firstName: "",
        lastName: "",
        mobile: "",
        email: "",
        address1: "",
        address2: "",
        address3: "",
        pinCode: "",
        city: "",
        state: "",
        companyName: "",
        gstNumber: "",
        licBranchNo: "",
        branchAddress: "",
        business: [],
        profileImage: null,
    };

    const validationSchema = Yup.object().shape({
        initial: Yup.string().required("Initial is required"),
        firstName: Yup.string().required("First name is required"),
        lastName: Yup.string().required("Last name is required"),
        mobile: Yup.string()
            .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits")
            .required("Mobile number is required"),
        email: Yup.string()
            .email('Enter a valid email address')
            .required('Email is required'), address1: Yup.string().required("Address 1 is required"),
        pinCode: Yup.string()
            .matches(/^[0-9]{6}$/, "Pin Code must be exactly 6 digits")
            .required("Pin Code is required"),
        city: Yup.string().required("City is required"),
        state: Yup.string().required("State is required"),
        business: Yup.array()
            .min(1, "Select at least one business association")
            .required("Select at least one business association"),
    });

    const allowOnlyNumbers = (e) => {
        const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
        if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
            e.preventDefault();
        }
    };

    return (
        <div className="formContainer lg:p-4 rounded" >
            <div className="flex flex-col lg:mx-5 p-4 border rounded bg-white" style={{ boxShadow: "0px 0px 12px #cac8c8" }}>
                <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4 px-2">
                    My Profile
                </h5>

                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        console.log("Form Data:", values);
                    }}
                >
                    {({ setFieldValue }) => (
                        <Form>
                            {/* Personal Information */}
                            <h6 className="text-secondary fw-bold mb-3  bg-gray-100 rounded p-2">
                                Personal Information
                            </h6>
                            <div className="row mb-3">
                                <div className="col-md-2 text-center">
                                    <div
                                        style={{
                                            width: "100px",
                                            height: "100px",
                                            borderRadius: "50%",
                                            border: "2px solid #ddd",
                                            overflow: "hidden",
                                            boxShadow: "0px 0px 5px rgba(0,0,0,0.2)",
                                            margin: "0 auto",
                                        }}
                                    >
                                        {profilePreview ? (
                                            <img
                                                src={profilePreview}
                                                alt="Profile"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                        ) : (
                                            <div
                                                className="d-flex align-items-center justify-content-center"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    backgroundColor: "#f0f0f0",
                                                }}
                                            >
                                                <i className="bi bi-person fs-1 text-secondary"></i>
                                            </div>
                                        )}
                                    </div>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        className="form-control mt-2"
                                        onChange={(event) => {
                                            const file = event.target.files[0];
                                            if (file) {
                                                setProfilePreview(URL.createObjectURL(file));
                                                setFieldValue("profileImage", file);
                                            }
                                        }}
                                    />
                                </div>

                                <div className="col-md-10">
                                    <div className="row">
                                        <div className="col-md-2 mb-3">
                                            <label className="form-label">Initial</label>
                                            <Field as="select" name="initial" className="form-control custom-shadow">
                                                <option value="">Select</option>
                                                <option value="Mr">Mr</option>
                                                <option value="Ms">Ms</option>
                                                <option value="Mrs">Mrs</option>
                                            </Field>
                                            <ErrorMessage
                                                name="initial"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </div>
                                        <div className="col-md-5 mb-3">
                                            <label className="form-label">First Name</label>
                                            <Field name="firstName" className="form-control custom-shadow" />
                                            <ErrorMessage
                                                name="firstName"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </div>
                                        <div className="col-md-5 mb-3">
                                            <label className="form-label">Last Name</label>
                                            <Field name="lastName" className="form-control custom-shadow" />
                                            <ErrorMessage
                                                name="lastName"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Mobile No</label>
                                            <Field
                                                name="mobile"
                                                className="form-control custom-shadow"
                                                maxLength={10}
                                                onKeyDown={allowOnlyNumbers}
                                            />
                                            <ErrorMessage
                                                name="mobile"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Email ID</label>
                                            <Field name="email" className="form-control custom-shadow" />
                                            <ErrorMessage
                                                name="email"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Address Information */}
                            <h6 className="text-secondary fw-bold mb-3 mt-4 bg-gray-100 rounded p-2">
                                Address Information
                            </h6>
                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label className="form-label">Address 1</label>
                                    <Field name="address1" className="form-control custom-shadow" />
                                    <ErrorMessage
                                        name="address1"
                                        component="div"
                                        className="text-danger"
                                    />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className="form-label">Address 2</label>
                                    <Field name="address2" className="form-control custom-shadow" />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className="form-label">Address 3</label>
                                    <Field name="address3" className="form-control custom-shadow" />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className="form-label">Pin Code</label>
                                    <Field
                                        name="pinCode"
                                        className="form-control custom-shadow"
                                        maxLength={6}
                                        onKeyDown={allowOnlyNumbers}
                                    />
                                    <ErrorMessage
                                        name="pinCode"
                                        component="div"
                                        className="text-danger"
                                    />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className="form-label">City</label>
                                    <Field name="city" className="form-control custom-shadow" />
                                    <ErrorMessage
                                        name="city"
                                        component="div"
                                        className="text-danger"
                                    />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className="form-label">State</label>
                                    <Field name="state" className="form-control custom-shadow" />
                                    <ErrorMessage
                                        name="state"
                                        component="div"
                                        className="text-danger"
                                    />
                                </div>
                            </div>

                            {/* Professional Information */}
                            <h6 className="text-secondary fw-bold mb-3 mt-4 bg-gray-100 rounded p-2">
                                Professional Information
                            </h6>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Company Name</label>
                                    <Field name="companyName" className="form-control custom-shadow" />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">GST Number</label>
                                    <Field name="gstNumber" className="form-control custom-shadow" />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Lic Branch No</label>
                                    <Field name="licBranchNo" className="form-control custom-shadow" />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Branch Address</label>
                                    <Field name="branchAddress" className="form-control custom-shadow" />
                                </div>
                            </div>

                            <div className="mb-3">
                                <label className="d-block">Business Associated with</label>

                                <div className="d-flex align-items-center gap-4">
                                    <div className="form-check d-flex align-items-center">
                                        <Field
                                            type="checkbox"
                                            name="business"
                                            value="Life Insurance"
                                            className="form-check-input me-2"
                                        />
                                        <label className="form-check-label mb-0">Life Insurance</label>
                                    </div>

                                    <div className="form-check d-flex align-items-center">
                                        <Field
                                            type="checkbox"
                                            name="business"
                                            value="General Insurance"
                                            className="form-check-input me-2"
                                        />
                                        <label className="form-check-label mb-0 ">General Insurance</label>
                                    </div>

                                    <div className="form-check d-flex align-items-center">
                                        <Field
                                            type="checkbox"
                                            name="business"
                                            value="Mutual Funds"
                                            className="form-check-input me-2"
                                        />
                                        <label className="form-check-label mb-0">Mutual Funds</label>
                                    </div>
                                </div>

                                <ErrorMessage
                                    name="business"
                                    component="div"
                                    className="text-danger"
                                />
                            </div>

                            {/* Buttons */}
                            <div className="d-flex justify-content-center gap-3 mt-4">
                                <button type="submit" className="saveButton d-flex align-items-center px-4" disabled={isSubmitting}>
                                    <LuSave className="me-2" />
                                    {isSubmitting ? "Saving..." : "Save"}
                                </button>
                                <button type="button" className="backButton d-flex align-items-center px-4" onClick={() => window.history.back()}>
                                    <GiCrossedBones className="me-2" />
                                    Cancel
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default AddNewProfile;
